<template>
    <div class="MlivingVideoList" :class="{showHeader: showHeader}">
      <div class="showHeader" v-if="showHeader">
        <mHeader v-if="showHeader"></mHeader>
        <van-tabs v-model:active="active" swipeable @change="handleTabsChange">
            <van-tab title="推荐"></van-tab>
            <van-tab title="快讯"></van-tab>
            <van-tab title="视频">
                <pull :pull="pull" :page="page" @getList="getList">
                    <NoData v-if="dataList.length === 0"></NoData>
                    <div v-else class="live_list_warp">
                        <div class="list_item_box" v-for="(obj, index) in dataList" :key="index" @click="handleClick(obj)">
                            <div class="img-box">
                                <img class="img" :src="obj.coverurl" alt="">
                                <span class="duration">{{obj.duration}}</span>
                            </div>
                            <div class="subject text-ellipses">{{obj.subject}}</div>
                            <div class="flex-between">
                              <div class="hostname_coverurl flex-start">
                                <img :src="obj.coverurl" alt="">
                                <span>{{obj.hostname}}</span>
                              </div>
                              <div class="oper flex-end">
                                  <div class="innerbox zan icon-m-zan flex-center pointer" :class="[obj.ispraise==1?'select':'']" @click.stop="handleZan(obj)">{{obj.praisecount}}</div>
                                  <div class="innerbox collect icon-m-collect flex-center pointer" :class="[obj.isfavorite==1?'select':'']" @click.stop="handleCollect(obj)"></div>
                                  <div class="innerbox collect icon-m-share flex-center pointer" @click.stop="handleShare(obj)" v-if="_isWixin()"></div>
                              </div>
                            </div>
                        </div>
                    </div>
                </pull>
            </van-tab>
            <van-tab title="PE/VC"></van-tab>
            <van-tab title="IPO"></van-tab>
            <van-tab title="并购"></van-tab>
            <van-tab title="产业"></van-tab>
            <van-tab title="智库"></van-tab>
        </van-tabs>
      </div>
      <div class="hideHeader" v-else>
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="dataList.length === 0"></NoData>
            <div v-else class="live_list_warp">
                <div class="list_item_box" v-for="(obj, index) in dataList" :key="index" @click="handleClick(obj)">
                    <div class="img-box">
                        <img class="img" :src="obj.coverurl" alt="">
                        <span class="duration">{{obj.duration}}</span>
                    </div>
                    <div class="subject text-ellipses">{{obj.subject}}</div>
                    <div class="flex-between">
                      <div class="hostname_coverurl flex-start">
                        <img :src="obj.coverurl" alt="">
                        <span>{{obj.hostname}}</span>
                      </div>
                      <div class="oper flex-end">
                          <div class="innerbox zan icon-m-zan flex-center pointer" :class="[obj.ispraise==1?'select':'']" @click.stop="handleZan(obj)">{{obj.praisecount}}</div>
                          <div class="innerbox collect icon-m-collect flex-center pointer" :class="[obj.isfavorite==1?'select':'']" @click.stop="handleCollect(obj)"></div>
                          <div class="innerbox collect icon-m-share flex-center pointer" @click.stop="handleShare(obj)" v-if="_isWixin()"></div>
                      </div>
                    </div>
                </div>
            </div>
        </pull>
      </div>
      <sharePopup ref="sharePopup"></sharePopup>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {getAllVideo} from 'api/web-app'
  import Pull from 'views/mobile/components/pull/pull'
  import NoData from 'views/mobile/components/noData/noData'
  import $ from 'jquery'
  import {addPraiseInfo} from 'api/pcvideo.js'
  import {uploadCourseFavorite} from 'api/public'
  import {getWXSDKSetting} from 'common/js/wxSDKSetting'
  import sharePopup from 'views/Mlive/livingVideo/components/livingSharePop.vue'
  import MHeader from 'views/mobile/components/mheader/mHeader'
  export default {
    name: 'MlivingVideoList',
    data() {
      return {
        dataList: [],
        param: {
          hostinnerid: this.$route.query.hostinnerid ? this.$route.query.hostinnerid: '',
          hostname: this.$route.query.hostname ? this.$route.query.hostname: ''
        },
        page: {
          page: 1,
          pagesize: 10,
          pageCount: 0,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
        active: 2,
        showHeader: false
      }
    },
    mounted() {
      if (location.search) {
          let searchArr = location.search.split('?')[1].split('&')
          searchArr.some(item => {
              if (item === 'showHeader') {
                this.showHeader = true
                return true
              }
          })
          console.log(searchArr)
      }
      if (this.param.hostname) {
        document.title = this.param.hostname + '-鲸融网-精品直播'
      } else {
        document.title = '鲸视频-鲸融网-精品直播'
      }
      $('html').scrollTop(0)
      if (!this.refresh) {
        this.getList()
      }
    },
    activated() {
      if (this.refresh) {
        this.getList()
        this.setRefresh(false)
      }
    },
    methods: {
      handleClick(obj) {
        this.$router.push({name: 'MlivingVideoView', query: {kmcinnerid: obj.kmcinnerid}})
      },
      _isWixin() {
        let ua = window.navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua)) {
          return true
        } else {
          return false
        }
      },
      handleShare(obj) {
        if (this._isWixin()) {
          let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?kmcinnerid=' + obj.kmcinnerid
          getWXSDKSetting({
            title: obj.subject,
            desc: obj.description,
            link: link,
            imgUrl: obj.coverurl,
          })
          this.$refs.sharePopup.open()
        }
      },
      handleZan(obj) {
        let ispraise = obj.ispraise == 1 ? 2 : 1
        this.setLoading(true)
        addPraiseInfo({
          data: {kmcinnerid: obj.kmcinnerid, kmctype: 4, optype: ispraise},
          success: () => {
            this.setLoading(false)
            if (ispraise == 2) {
              this.$toast.success('取消成功')
              obj.praisecount--
              obj.ispraise = 0
            } else {
              this.$toast.success('收藏成功')
              obj.praisecount++
              obj.ispraise = 1
            }
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      handleCollect(obj) {
        let isfavorite = obj.isfavorite == 1 ? 2 : 1
        this.setLoading(true)
        uploadCourseFavorite({
          data: {optype: isfavorite, courseid: obj.kmcinnerid, kmctype: 4},
          success: () => {
            if (isfavorite == 2) {
              this.$toast.success('取消成功')
              obj.favoritedcount--
              obj.isfavorite = 0
            } else {
              this.$toast.success('点赞成功')
              obj.favoritedcount++
              obj.isfavorite = 1
            }
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getList() {
        this.setLoading(true)
        getAllVideo({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            this.init = true
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.dataList = data.data.content
            } else {
              this.dataList = this.dataList.concat(data.data.content)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      handleTabsChange(index) {
          if (Number(index) === 1) {
              if (location.hostname.indexOf('zj178') >= 0) {
                  location.href = location.protocol + '//m.zj178.com/mtelegraph'
              } else {
                  location.href = location.protocol + '//m.capwhale.com/mtelegraph'
              }
          } else {
              if (location.hostname.indexOf('zj178') >= 0) {
                  location.href = location.protocol + '//m.zj178.com/index?activeTabsIndex=' + index
              } else {
                  location.href = location.protocol + '//m.capwhale.com/index?activeTabsIndex=' + index
              }
          }
      },
      ...mapActions([
        'setLoading', 'setNoDataTip'
      ])
    },
    filters: {},
    watch: {
      showAppTips: {
        handler(newV) {
            if (this.showHeader) {
                if (newV) {
                    document.getElementsByClassName('van-tabs__content')[0].style.height = 'calc(100vh - 0.98rem - 1.98rem)'
                    document.getElementsByClassName('MlivingVideoList')[0].style.paddingTop = '1.98rem'
                } else {
                    document.getElementsByClassName('van-tabs__content')[0].style.height = 'calc(100vh - 0.98rem - 0.88rem)'
                    document.getElementsByClassName('MlivingVideoList')[0].style.paddingTop = '0.88rem'
                  }
            }
            
        }
      }
    },
    computed: {
      ...mapGetters(['user', 'showAppTips'])
    },
    components: {Pull, NoData, sharePopup, MHeader}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MlivingVideoList {
        min-height: 100vh;
        background-color: #fff;
        box-sizing: border-box;
        &.showHeader {
            padding-top: 1.98rem;
        }
        .van-tabs {
            .van-tabs__wrap {
                height: 0.98rem;
                .van-tabs__nav {
                    padding-bottom: 0;
                    .van-tab {
                        width: 0.64rem;
                        max-width: 0.64rem;
                        padding: 0;
                        font-size: 0.3rem;
                        color: #333333;
                        margin-left: 0.4rem;
                        text-overflow: initial;
                        &.van-tab--active {
                            color: #1464C8;
                            .van-tab__text {
                                font-weight: bold;
                            }
                        }
                        &:nth-of-type(4) {
                            width: 0.95rem;
                            max-width: 0.95rem;
                        }
                    }
                    .van-tabs__line {
                        width: 0.64rem !important;
                        background: #1464C8;
                        bottom: 0.2rem;
                    }
                }
            }
            .van-tabs__content {
              height: calc(100vh - 0.98rem);
              .van-tab__pane {
                height: 100%;
                overflow-y: scroll;
              }
            }
        }
        &.showHeader {
            .van-tabs {
              .van-tabs__content {
                  height: calc(100vh - 1.98rem);
              }
            }
        }
        .live_list_warp{
            padding: 0 0.32rem;
            .list_item_box{
                padding: 0.32rem 0;
                &:not(:first-of-type) {
                    border-top: 0.01rem solid #E5E5E5;
                }
                .img-box{
                    width: 6.86rem;
                    height: 3.84rem;
                    border-radius: 0.04rem;
                    margin-bottom: 0.3rem;
                    position: relative;
                    .img{
                        width: 100%;
                        height: 100%;
                    }
                    &:after{
                        content: '';
                        display: inline-block;
                        position: absolute;
                        top: calc(50% - 0.44rem);
                        left: calc(50% - 0.44rem);
                        width: 0.88rem;
                        height: 0.88rem;
                        background: url("~common/images/mliveimgs/icon-player.svg");
                        background-size: 100%;
                    }
                    .duration{
                        padding: 0 0.12rem;
                        height: 0.36rem;
                        line-height: 0.36rem;
                        position: absolute;
                        bottom: 0.16rem;
                        right: 0.16rem;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 20px;
                        font-size: 0.24rem;
                        color: #fff;
                    }
                }
                .subject{
                    font-size: 0.32rem;
                    line-height: 0.45rem;
                    margin-bottom: 0.2rem;
                }
                .hostname_coverurl {
                  font-size: 0.28rem;
                  color: #999;
                  img {
                    width: 0.42rem;
                    height: 0.42rem;
                    border-radius: 50%;
                    margin-right: 0.12rem;
                  }
                }
                .oper{
                    font-size: 0.26rem;
                    .innerbox{
                        color: #CCCCCC;
                        &+.innerbox{
                            margin-left: 0.35rem;
                        }
                        &:before{
                            width: 0.32rem;
                            height: 0.32rem;
                        }
                    }
                    .zan:before{
                        margin-right: 0.1rem;
                    }
                    .select.zan{
                        color: #EC5E69;
                    }
                }
            }
        }
    }
</style>